import BtnNavigateBack from "@/components/ui/btn_navigate_back";
import { Card } from "@/components/ui/card";
import { CarValuationWidget } from "@/components/valuation/CarValuationWidget";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n/labels/commonLabels";
import { useShowNavigateBack } from "@/hooks/useShowNavigateBack";

const CarValuation = () => {
  const showPageBack = useShowNavigateBack();
  const { language } = useLanguage();
  const backLabel = commonLabels(language).buttons?.back ?? "Tillbaka";
  return (
    <div className="w-full px-2 sm:px-4 pt-6 md:pt-8">
      <div
        className={
          showPageBack
            ? "grid grid-cols-1 md:grid-cols-[auto_minmax(0,1fr)] items-start gap-y-2 gap-x-3 max-w-2xl md:max-w-none mx-auto"
            : "max-w-2xl mx-auto"
        }
      >
        {showPageBack && (
          <BtnNavigateBack
            label={backLabel}
            to="/list-or-value-car"
            className="!mb-0 w-fit justify-start px-0 md:pt-1"
          />
        )}
        <Card className="relative w-full max-w-2xl px-3 sm:px-4 md:px-8 py-4 space-y-2 glass-card">
          <CarValuationWidget />
        </Card>
      </div>
    </div>
  );
};

export default CarValuation;
